import { Component } from "react";
import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { ContainerRegistryLayout } from "../ContainerRegistryLayout";
import { ContainerRegistryRouterProps } from "../ContainerRegistryRouterProps";

export interface HomePageProps extends NSARouterMakerResult, ContainerRegistryRouterProps { }

class HomePage extends Component<HomePageProps>
{
    override render()
    {
        return (
            <ContainerRegistryLayout {...this.props}>
                <NSAHomePage {...this.props} />
            </ContainerRegistryLayout>
        )
    }
}

export default HomePage;